<template>
  <a-drawer
    class="detail-drawer"
    :destroy-on-close="true"
    :title="detail.name"
    :visible="visible"
    :width="1200"
    @close="visible = false"
  >
    <a-descriptions>
      <a-descriptions-item label="创建人">
        {{ detail.created_by.nickname }}
      </a-descriptions-item>
      <a-descriptions-item label="创建时间">
        {{ detail.created_at }}
      </a-descriptions-item>
      <a-descriptions-item label="更新人">
        {{ detail.updated_by.nickname }}
      </a-descriptions-item>
      <a-descriptions-item label="更新时间">
        {{ detail.updated_at }}
      </a-descriptions-item>
    </a-descriptions>
    <rich-text v-model="detail.content" :read-only="true"></rich-text>
  </a-drawer>
</template>

<script>
import { getDocument } from '@/api/document'
import RichText from '@/components/RichText'

export default {
  name: 'DocumentDrawer',
  components: {
    RichText
  },
  data () {
    return {
      visible: false,
      detail: {
        id: '',
        name: '',
        description: '',
        content: '',
        created_by: {
          nickname: ''
        },
        updated_by: {
          nickname: ''
        }
      }
    }
  },
  methods: {
    show (id) {
      getDocument(id)
        .then(res => {
          this.detail = res.data
        })
        .finally(() => {
          this.visible = true
        })
    }
  }
}
</script>
